export default __webpack_public_path__ + "113fef7580e24400d98568496182cfa2.png";